import { render, staticRenderFns } from "./ReviewQuestionModal.vue?vue&type=template&id=0f506da8&"
import script from "./ReviewQuestionModal.vue?vue&type=script&lang=ts&"
export * from "./ReviewQuestionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports